import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dakaiwenjianjia",
  "use": "icon-dakaiwenjianjia-usage",
  "viewBox": "0 0 1350 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1350 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dakaiwenjianjia\"><path d=\"M1088 128H576l-128-128H128C57.6 0 0 57.6 0 128v768c0 70.4 57.6 128 128 128h992c54.4 0 96-41.6 96-96V256c0-70.4-57.6-128-128-128z\" /><path d=\"M1222.4 320H361.6c-60.8 0-115.2 44.8-124.8 105.6L128 1024h1014.4c60.8 0 115.2-44.8 124.8-105.6l80-448c16-76.8-44.8-150.4-124.8-150.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol